import { useNamespaceCopy } from '@/i18n/ns';
import { usageCopy, type UsageCopyKey } from '@/i18n/ns/usage';

export type UsageCopy = Readonly<Record<UsageCopyKey, string>>;

export const useUsageCopy = (): UsageCopy => useNamespaceCopy(usageCopy);
